<div
  class="flex flex-row flex-wrap gap-2 rounded-lg p-2"
  [ngClass]="colourClass()"
>
  <div class="flex grow flex-row items-center gap-2">
    <div class="flex items-center justify-center">
      <mat-icon [color]="theme() === 'warn' ? 'warn' : 'primary'">{{
        icon()
      }}</mat-icon>
    </div>
    <p class="!m-0 flex flex-auto flex-col">
      <ng-content />
    </p>
  </div>
  @if (buttonQueryList?.length) {
    <div class="flex flex-row items-center gap-2">
      <ng-content select="button" />
    </div>
  }
</div>
